import { DropdownMenuOptions } from "./DropdownMenuItem"

export const UNNAME_GROUP_TITLE = "-"

export const transformOptionsToGroups = (
  options: DropdownMenuOptions[],
  groupBy: (option: DropdownMenuOptions) => string
): Record<string, DropdownMenuOptions[]> =>
  options.reduce<Record<string, DropdownMenuOptions[]>>((res, option) => {
    const groupTitle = groupBy?.(option)
    const group = !!groupTitle ? res[groupTitle] : res[UNNAME_GROUP_TITLE]

    return {
      ...res,
      [groupTitle || UNNAME_GROUP_TITLE]: [...(group || []), option]
    }
  }, {})
